import { Box, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import React, { useMemo } from "react";

import CustomDataGrid from "components/common/CustomDataGrid";
import { EDefaultValues } from "constants/defaultValues";
import { BranchDto } from "libs/cellera-sdk";
import { v4 as uuidv4 } from "uuid";

interface PracticeUserBranchesSectionProps {
  branches: BranchDto[];
  minHeight?: number;
}

const PracticeUserBranchesSection: React.FC<
  PracticeUserBranchesSectionProps
> = ({ branches, minHeight = 150 }) => {
  const columns: GridColDef<BranchDto>[] = useMemo(
    () => [
      {
        field: "address",
        headerName: "Address",
        flex: 1,
        renderCell: (params) => {
          return params.value || EDefaultValues.EMPTY_STRING;
        },
      },
      {
        field: "emailAddress",
        headerName: "Email Address",
        flex: 1,
        renderCell: (params) => {
          return params.value || EDefaultValues.EMPTY_STRING;
        },
      },
      {
        field: "primaryPhoneNumber",
        headerName: "Primary Phone Number",
        flex: 1,
        renderCell: (params) => {
          return params.value || EDefaultValues.EMPTY_STRING;
        },
      },
      {
        field: "faxNumber",
        headerName: "Fax Number",
        flex: 1,
        renderCell: (params) => {
          return params.value || EDefaultValues.EMPTY_STRING;
        },
      },
    ],
    [],
  );

  const rows = useMemo(
    () =>
      branches.map((branch) => ({
        id: branch.id || uuidv4(),
        address: branch.address,
        emailAddress: branch.emailAddress,
        primaryPhoneNumber: branch.primaryPhoneNumber,
        faxNumber: branch.faxNumber,
      })),
    [branches],
  );

  return (
    <Box
      sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 4, mb: 4 }}
    >
      <Typography variant="h6" sx={{ fontSize: "1.25rem", fontWeight: 500 }}>
        Branches
      </Typography>
      <Box sx={{ position: "relative", width: "100%" }}>
        <CustomDataGrid rows={rows} columns={columns} minHeight={minHeight} />
      </Box>
    </Box>
  );
};

export default PracticeUserBranchesSection;
